module.exports = "/hwa/_next/static/images/soil-4a5f49eed1be850bcdbc1cb8556c40a3.png";